import React from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { motion } from "framer-motion";
import { Settings } from "@mui/icons-material";

function ExtraSettings({ settings, handleExtraSettingsToggle }) {
  const handleToggle = (index, checked) => {
    handleExtraSettingsToggle(index, checked);
  };

  const cardVariants = {
    initial: { scale: 1 },
    hover: { scale: 1.02, boxShadow: "0 10px 20px rgba(0,0,0,0.1)" },
    tap: { scale: 0.98 }
  };

  // Create pairs of settings
  const getPairedSettings = () => {
    if (!settings?.extraSettings?.length) return [];

    const pairs = [];
    for (let i = 0; i < settings.extraSettings.length; i += 2) {
      pairs.push(settings.extraSettings.slice(i, i + 2));
    }
    return pairs;
  };

  return (
    <motion.div
      initial={{ y: 40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.3 }}
    >
      <motion.div variants={cardVariants} initial="initial" whileHover="hover">
        <Card className="shadow-sm mb-0">
          <Card.Header className="bg-white py-3">
            <h5 className="mb-0">
              <Settings className="me-2 text-primary" /> Ek Ayarlar
            </h5>
          </Card.Header>
          <Card.Body>
            {settings?.extraSettings && settings.extraSettings.length > 0 ? (
              getPairedSettings().map((pair, pairIndex) => (
                <Row key={`pair-${pairIndex}`} className="mb-4">
                  {pair.map((setting, index) => {
                    const actualIndex = pairIndex * 2 + index;
                    return (
                      <Col key={setting.key} xs={12} md={6} className="mb-3 mb-md-0">
                        <motion.div
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ delay: 0.1 * actualIndex }}
                          className="border rounded p-3 h-100"
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h6 className="fw-bold mb-1">{setting.value}</h6>
                              <p className="text-muted small mb-0">{setting.key}</p>
                            </div>
                            <div
                              onClick={() => handleToggle(actualIndex, !setting.enabled)}
                              className="d-flex justify-content-end align-items-center cursor-pointer"
                            >
                              <Badge
                                bg={setting.enabled ? "success" : "secondary"}
                                pill
                                className={`px-3 py-2 ${setting.enabled && "text-white"}`}
                              >
                                {setting.enabled ? "Aktif" : "Pasif"}
                              </Badge>
                            </div>
                          </div>
                        </motion.div>
                      </Col>
                    );
                  })}
                </Row>
              ))
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">Herhangi bir ek ayar tanımlanmamış.</p>
              </div>
            )}
          </Card.Body>
        </Card>
      </motion.div>
    </motion.div>
  );
}

export default ExtraSettings;
